import { useState, useEffect } from 'react';
import { getUsers } from '@/actions/data-fetch-users';
import { UsersClientWrapper } from './UsersClientWrapper';
import { UsersDetail, PaginationProps } from '@/types/settings/settings';

export default function UsersPage() {
    const [initialData, setInitialData] = useState<UsersDetail[] | undefined>(undefined);
    const [pagination, setPagination] = useState<PaginationProps | undefined>(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getUsers({
                    page: 1
                });
                
                setInitialData(response.data.users);
                setPagination(response.data.pagination);
            } catch (err) {
                console.error('Error fetching users:', err);
                setError('Failed to load users');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-lg">Loading users...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-lg text-red-600">{error}</div>
            </div>
        );
    }

    return (
        <div className="h-full">
            <UsersClientWrapper
                initialData={initialData}
                pagination={pagination}
            />
        </div>
    );
}